export default __webpack_public_path__ + "static/media/linkedin.ceead9a9.svg";